const MasterScreenReducer = (state = {}, action) => {
  switch (action.type) {
    case "editEquipment":
      return Object.assign({}, state, {
        editEquipment: action.data,
      });
      break;
    case "MapPopup":
      return Object.assign({}, state, {
        ShipData: action.data,
      });
      break;
    case "getShipManagementListSuccess":
      return Object.assign({}, state, {
        ShipManagementList: action.data,
      });
      break;
    case "getShipManagementDetailSuccess":
      return Object.assign({}, state, {
        ShipManagementDetails: action.data,
      });
      break;
    case "getInactiveShipListSuccess":
      return Object.assign({}, state, {
        InactiveShipsList: action.data,
      });
      break;
    case "getInactiveShipDetailSuccess":
      return Object.assign({}, state, {
        InactiveShipDetails: action.data,
      });
      break;


    case "ViewFlagDetails":
      return Object.assign({}, state, {
        FlagManagementDetails: action.data,
      });
      break;
    case "ViewClassDetails":
      return Object.assign({}, state, {
        ClassManagementDetails: action.data,
      });
      break;
    case "getShipEquipmentDetailSuccess":
      return Object.assign({}, state, {
        ShipEquipmentDetails: action.data,
      });
      break;
    case "getClientManagementListSuccess":
      return Object.assign({}, state, {
        ClientList: action.data,
      });
      break;
    case "getClientDetailsSuccess":
      return Object.assign({}, state, {
        ClientManagementDetails: action.data,
      });
      break;
    case "fleetManagerListSuccess":
      return Object.assign({}, state, {
        fleetManagerList: action.data,
      });
      break;
    case "fetchClientList":
      return Object.assign({},state,{
        getClientLists:action.data
      })
      break;
    case "techSuperintendentListSuccess":
      return Object.assign({}, state, {
        techSuperintendentList: action.data,
      });
      break;
    case "techExecutiveListSuccess":
      return Object.assign({}, state, {
        techExecutiveList: action.data,
      });
      break;
    case "fleetManagerDetail":
      return Object.assign({}, state, {
        fleetManagerDetail: action.data,
      });
      break;
    case "techSuperintendentDetail":
      return Object.assign({}, state, {
        techSuperintendentDetail: action.data,
      });
      break;
    case "techExecutiveDetail":
      return Object.assign({}, state, {
        techExecutiveDetail: action.data,
      });
      break;
    case "EditUser":
      return Object.assign({}, state, {
        EditUser: action.data,
      });
      break;
    case "getEquipmentListSuccess":
      return Object.assign({}, state, {
        EquipmentList: action.data,
      });
      break;
    case "getEquipmentDetailSuccess":
      return Object.assign({}, state, {
        EquipmentDetail: action.data,
      });
      break;
    case "getEquipmentUsedSuccess":
      return Object.assign({}, state, {
        EquipmentUsed: action.data,
      });
      break;
    case "getPortListSuccess":
      return Object.assign({}, state, {
        PortList: action.data,
      });
      break;
    case "getPortNameListSuccess":
      return Object.assign({}, state, {
        PortNameList: action.data,
      });
      break;
    case "getApplicableSeviceTypewithIdListSuccess":
      return Object.assign({}, state, {
        applicableServiceTypeList: action.data,
      });
      break;
    case "getIntervalServiceTypeListSuccess":
      return Object.assign({}, state, {
        applicableServiceTypeInterval: action.data,
      });
      break;
    case "getServiceTypeIntervalListFlagSuccess":
      return Object.assign({}, state, {
        applicableServiceType: action.data,
      });
      break;
    case "getServiceTypeIntervalListClassSuccess":
      return Object.assign({}, state, {
        ClassapplicableServiceType: action.data,
      });
      break;
    case "getServiceTypeIntervalListMiscSuccess":
      return Object.assign({}, state, {
        MiscapplicableServiceType: action.data,
      });
      break;
    case "getServiceTypeIntervalListSuccess":
      return Object.assign({}, state, {
        applicableServiceTypeInterval: action.data,
      });
      break;
    case "getServiceTypeBudgetListSuccess":
      return Object.assign({}, state, {
        applicableServiceTypeBudget: action.data,
      });
      break;

    case "getServiceDateSuccess":
      return Object.assign({}, state, {
        ServiceDate: action.data,
      });
      break;
    case "getServiceDatelistSuccess":
      return Object.assign({}, state, {
        ServiceDatelist: action.data,
      });
      break;
    case "getPortDetailSuccess":
      return Object.assign({}, state, {
        PortDetail: action.data,
      });
      break;
    case "MakeDetailsSuccess":
      return Object.assign({}, state, {
        MakeDetail: action.data,
      });
      break;

    case "getServiceProviderListSuccess":
      return Object.assign({}, state, {
        ServiceProviderList: action.data,
      });
      break;
    case "getPortListsSuccess":
      return Object.assign({}, state, {
        PortLists: action.data,
      });
      break;
    case "getCountryListSuccess":
      return Object.assign({}, state, {
        CountryList: action.data,
      });
      break;
    case "getServiceProviderPortListSuccess":
      return Object.assign({}, state, {
        ServiceProviderPortList: action.data,
      });
      break;
    case "getShipPortListSuccess":
      return Object.assign({}, state, {
        ShipPortList: action.data,
      });
      break;
    case "getShipCountryListSuccess":
      return Object.assign({}, state, {
        ShipCountryList: action.data,
      });
      break;
    case "getShipServiceProviderPortListSuccess":
      return Object.assign({}, state, {
        ShipServiceProviderPortList: action.data,
      });
      break;
    case "getAllShipPortListSuccess":
      return Object.assign({}, state, {
        ShipPortListAll: action.data,
      });
      break;
    case "getAllShipCountryListSuccess":
      return Object.assign({}, state, {
        ShipCountryListAll: action.data,
      });
      break;
    case "getAllShipServiceProviderPortListSuccess":
      return Object.assign({}, state, {
        ShipServiceProviderPortListAll: action.data,
      });
      break;
    case "getShipServiceProviderIDSuccess":
      return Object.assign({}, state, {
        ShipServiceProviderID: action.data,
      });
      break;
    case "getPortAndCountrySuccess":
      return Object.assign({}, state, {
        PortAndCountry: action.data,
      });
      break;
    case "getPortCountrySuccess":
      return Object.assign({}, state, {
        PortCountry: action.data,
      });
      break;
    case "getServiceProviderDetailSuccess":
      return Object.assign({}, state, {
        ServiceProviderDetail: action.data,
      });
      break;
    case "getflagListSuccess":
      return Object.assign({}, state, {
        flagList: action.data.flags,
      });
      break;
    case "getClientNameListSuccess":
      return Object.assign({}, state, {
        ClientNameList: action.data,
      });
      break;
    case "postAdhocAnalysisSuccess":
      return Object.assign({}, state, {
        AdhocTableData: action.data.data,
        AdhocPagination: action.data.data.pagination
      });
      break;
    case "adhocAnalysisiSearch":
      return Object.assign({}, state, {
        adhocAnalysisiSearch: action.data
      });
      break;

    case "postAdhocAnalysisFailure":
      return Object.assign({}, state, {
        AdhocTableData: []
      });
      break;
    case "getClientUserListSuccess":
      return Object.assign({}, state, {
        ClientUsersList: action.data,
      });
      break;
    case "getMakesListSuccess":
      return Object.assign({}, state, {
        MakeList: action.data,
      });
      break;
    case "getModelsListSuccess":
      return Object.assign({}, state, {
        ModelList: action.data,
      });
      break;
    case "getMakesListEquipmentSuccess":
      return Object.assign({}, state, {
        MakeEquipmentList: action.data,
      });
      break;
    case "getModelsListEquipmentSuccess":
      return Object.assign({}, state, {
        ModelEquipmentList: action.data,
      });
      break;
    case "getClientUsersDetailsSuccess":
      return Object.assign({}, state, {
        ClientUsersDetails: action.data,
      });
      break;
    case "getModelsOthersListSuccess":
      return Object.assign({}, state, {
        ModelOthersList: action.data,
      });
      break;
    case "getEquipmentNameListSuccess":
      return Object.assign({}, state, {
        EquipmentNameList: action.data,
      });
      break;
    case "getEquipmentNameListAndIdSuccess":
      return Object.assign({}, state, {
        EquipmentNameListAndId: action.data,
      });
      break;
    case "FlagApplicableServices":
      return Object.assign({}, state, {
        FlagApplicableServices: action.data,
      });
      break;
    case "ClassApplicableServices":
      return Object.assign({}, state, {
        ClassApplicableServices: action.data,
      });
      break;

    case "getMiscApplicableServiceSuccess":
      return Object.assign({}, state, {
        MiscApplicableServices: action.data,
      });
      break;
    case "getCategoryListSuccess":
      return Object.assign({}, state, {
        CategoryList: action.data,
      });
      break;
    case "getEquipmentTypeListSuccess":
      return Object.assign({}, state, {
        EquipmentTypeList: action.data,
      });
      break;
    case "getEquipmentDropDownListSuccess":
      return Object.assign({}, state, {
        EquipmentDropDownList: action.data,
      });
      break;
    case "getShipStatusListSuccess":
      return Object.assign({}, state, {
        ShipStatusList: action.data,
      });
      break;
    case "getEquipmentNameList":
      return Object.assign({}, state, {
        EquipmentNameList1: action.data,
      });
      break;
    case "getCategoryNameList":
      return Object.assign({}, state, {
        CategoryNameList: action.data,
      });
      break;
    case "getTypeofShipListSuccess":
      return Object.assign({}, state, {
        TypeofShipList: action.data,
      });
      break;
    case "getMiscTypeListListSuccess":
      return Object.assign({}, state, {
        MiscTypeofList: action.data,
      });
      break;
    case "annualAttachmentUploadSuccess":
      return Object.assign({}, state, {
        annualAttachment: action.data,
      });
      break;
    case "serviceAttachmentUploadSuccess":
      return Object.assign({}, state, {
        serviceAttachment: action.data,
      });
      break;
    case "biannualAttachmentUploadSuccess":
      return Object.assign({}, state, {
        biannualAttachment: action.data,
      });
      break;
    case "fiveyearlyAttachmentUploadSuccess":
      return Object.assign({}, state, {
        fiveyearlyAttachment: action.data,
      });
      break;
    case "tenyearlyAttachmentUploadSuccess":
      return Object.assign({}, state, {
        tenyearlyAttachment: action.data,
      });
      break;
    case "getEquipmentArray":
      return Object.assign({}, state, {
        EquipmentArray: action.data,
      });
      break;
    case "getEquipmentDetails":
      return Object.assign({}, state, {
        EquipmentObject: action.data,
      });
      break;
    case "getEquipmentMakeModelDetailsSuccess":
      return Object.assign({}, state, {
        EquipmentMakeModel: action.data,
      });
      break;
    case "companyName":
      return Object.assign({}, state, {
        companyName: action.data,
      });
      break;
    case "StaffDetails":
      return Object.assign({}, state, {
        StaffDetails: action.data,
      });
      break;
    case "ClientContactUserDetails":
      return Object.assign({}, state, {
        ClientContactUserDetails: action.data,
      });
      break;
    //Equipment dropdown reducres
    case "getDropdownEquipmentNameListSuccess":
      return Object.assign({}, state, {
        DropdownEquipmentList: action.data,
      });
      break;
    case "getDropdownMakesListSuccess":
      return Object.assign({}, state, {
        DropdownMakeList: action.data,
      });
      break;
    case "getDropdownModelsListSuccess":
      return Object.assign({}, state, {
        DropdownModelList: action.data,
      });
      break;
    case "getDropdownEquipmentTypeListSuccess":
      return Object.assign({}, state, {
        DropdownEquipmentTypeList: action.data,
      });
      break;
    case "getdropdownCategoryListSuccess":
      return Object.assign({}, state, {
        DropdownCategoryList: action.data,
      });
      break; case "getDropdownApplicableSeviceTypeListSuccess":
      return Object.assign({}, state, {
        DropdownServiceTypeList: action.data,
      });
      break;
    //classdetailsget
    case "getClassListSuccess":
      return Object.assign({}, state, {
        ClassList: action.data.list,
      });
      break;
    case "classDetails":
      return Object.assign({}, state, {
        ClassListDetails: action.data,
      });
      break;
    //Miscdetailsget
    case "getMiscListSuccess":
      return Object.assign({}, state, {
        MiscList: action.data.list,
      });
      break;
    case "MiscDetails":
      return Object.assign({}, state, {
        MiscListDetails: action.data,
      });
      break;

    case "MiscApplicableServices":
      return Object.assign({}, state, {
        NewMiscApplicableServices: action.data,
      });
      break;
    case "equipmentSearch":
      return Object.assign({}, state, {
        equipmentSearch: action.data,
      });
      break;
    case "portSearch":
      return Object.assign({}, state, {
        portSearch: action.data,
      });
      break;
    case "serviceBySearch":
      return Object.assign({}, state, {
        serviceBySearch: action.data,
      });
      break;
    case "clientuserSearch":
      return Object.assign({}, state, {
        clientuserSearch: action.data,
      });
      break;
    default: {
      return state;
    }
  }
};
export default MasterScreenReducer;
